import { ADMIN_PERMISSIONS } from '@/constants/permissions.js'
import { UUID_PATTERN } from '@/constants/uuid.js'

const admin = [
  {
    path: '/admin',
    redirect: '/admin/painel',
    name: 'Painel Administrativo',
    meta: {
      auth: true,
      admin: true,
    },
    component: () => import('@/view/Layouts/DashContainer/DashContainer.vue'),
    children: [
      {
        path: 'painel',
        name: 'Ações',
        component: () => import('@/view/pages/admin/Overview.vue'),
      },
      {
        path: 'ordens_pagamento',
        name: 'Admin - Listagem de Ordens de Pagamentos',
        component: () => import('@/view/pages/admin/ordens_de_pagamentos/PaymentOrdersList.vue'),
        // Fonte única de verdade para sidebar (_menu.js) e cards do painel
        // (view/pages/admin/Overview.vue) — ambos leem via getAdminPermission.
        meta: {
          adminPermission: ADMIN_PERMISSIONS.VIEW_PAYMENT_ORDERS,
        },
        children: [
          {
            path: '',
            name: 'Admin - Ordens de Pagamentos',
            redirect: '/admin/ordens_pagamento/lista',
          },
          {
            path: 'lista',
            name: 'Admin - Lista de Ordens de Pagamentos',
            component: () =>
              import(
                '@/view/pages/admin/ordens_de_pagamentos/Tables/UnclaimedPaymentOrdersTable.vue'
              ),
          },
          {
            path: 'resgatadas',
            name: 'Admin - Lista de Ordens de Pagamentos Resgatadas',
            component: () =>
              import(
                '@/view/pages/admin/ordens_de_pagamentos/Tables/ClaimedPaymentOrdersTable.vue'
              ),
          },
        ],
      },
      {
        path: 'planos_servicos',
        name: 'Admin - Planos e Servicos',
        component: () => import('@/view/pages/admin/planos_servicos/PlansAndServices.vue'),
        meta: {
          adminPermission: ADMIN_PERMISSIONS.VIEW_PLANS_SERVICES,
        },
      },
      {
        path: 'correcao_transacoes',
        name: 'Admin - Correção de Transação e Extrato',
        component: () => import('@/view/pages/admin/correct_transaction/Overview.vue'),
        meta: {
          adminPermission: ADMIN_PERMISSIONS.CORRECT_TRANSACTION_STATEMENT,
        },
      },
      {
        path: 'cash_out',
        component: () => import('@/view/pages/admin/cash_out/CashOutTransactions.vue'),
        meta: {
          adminPermission: ADMIN_PERMISSIONS.VIEW_CASH_OUT,
        },
        children: [
          {
            path: '',
            name: 'Admin -Transações Cash Out',
            redirect: '/admin/cash_out/lista_pagamentos',
          },
          {
            path: 'lista_pagamentos',
            name: 'Listagem de Pagamentos',
            component: () => import('@/view/pages/admin/cash_out/pagamentos/PaymentsList.vue'),
          },
          {
            path: 'ted_doc',
            name: 'Listagem de Transações',
            component: () => import('@/view/pages/admin/cash_out/doc_ted/docAndTedList.vue'),
          },
          {
            path: 'pix',
            name: 'Listagem de Transações PIX',
            component: () => import('@/view/pages/shared/pix/Pages/PixAreaTable.vue'),
          },
        ],
      },
      {
        path: 'cash_in',
        component: () => import('@/view/pages/admin/cash_in/CashInTransactions.vue'),
        meta: {
          adminPermission: ADMIN_PERMISSIONS.VIEW_CASH_IN,
        },
        children: [
          {
            path: '',
            name: 'Admin - Transações Cash In',
            redirect: '/admin/cash_in/boleto',
          },
          {
            path: 'boleto',
            name: 'Admin - Cash In - Boleto Depósito',
            component: () => import('@/view/pages/shared/deposit/Tables/BoletoDepositoTable.vue'),
          },
          {
            path: 'imopix',
            name: 'Admin - Cash In - ImoPIX',
            component: () => import('@/view/pages/shared/deposit/Tables/PixDepositoTable.vue'),
          },
          {
            path: 'reconhecimento',
            name: 'Admin - Cash In - Reconhecimento de Depósito',
            component: () =>
              import('@/view/pages/admin/cash_in/reconhecimento/RecognitionList.vue'),
          },
        ],
      },
      {
        path: 'relatorios',
        component: () => import('@/view/pages/admin/relatorios/Reports.vue'),
        meta: {
          adminPermission: ADMIN_PERMISSIONS.ISSUE_REPORTS,
        },
        children: [
          {
            path: '',
            name: 'Admin - Relatorios Administrativos',
            redirect: '/admin/relatorios/diario-operacoes',
          },
          {
            path: 'diario-operacoes',
            name: 'Relatório Diário de Operações',
            component: () =>
              import('@/view/pages/admin/relatorios/Tables/DiarioOperacoesDigitais.vue'),
          },
          {
            path: 'saldos-custodiados',
            name: 'Relatório de Saldos Custodiados',
            component: () =>
              import('@/view/pages/admin/relatorios/Tables/SaldosCustodiadosTable.vue'),
          },
          {
            path: 'movimento-tesouraria',
            name: 'Relatório de Movimento de Tesouraria',
            component: () =>
              import('@/view/pages/admin/relatorios/Tables/TreasuryMovementTable.vue'),
          },
          {
            path: 'credores',
            name: 'Relatório de Credores',
            component: () =>
              import('@/view/pages/admin/relatorios/Tables/RegisteredCreditorsTable.vue'),
          },
          {
            path: 'credores-regiao',
            name: 'Relatório de Credores por Região',
            component: () =>
              import('@/view/pages/admin/relatorios/Tables/CreditorsByRegionTable.vue'),
          },
        ],
      },
      {
        path: 'contabilidade',
        component: () => import('@/view/pages/admin/accounting/Accounting.vue'),
        meta: {
          adminPermission: ADMIN_PERMISSIONS.ACCOUNTING_AREA,
        },
        children: [
          {
            path: '',
            name: 'Admin - Contabilidade',
            redirect: '/admin/contabilidade/tarifas',
          },
          {
            path: 'tarifas',
            name: 'Admin - Tarifas',
            component: () => import('@/view/pages/admin/accounting/pages/fee.vue'),
          },
          {
            path: 'nfses',
            name: 'Admin - NFSes',
            component: () => import('@/view/pages/admin/accounting/pages/nfse.vue'),
          },
        ],
      },
      {
        path: 'nfses/details/:id',
        name: 'Admin - Detalhes de NFSe',
        component: () => import('@/view/pages/admin/accounting/nfses/Details.vue'),
      },
      {
        path: 'taxas',
        name: 'Admin - Taxas Imoabanco',
        component: () => import('@/view/pages/admin/taxas_imobanco/feeList.vue'),
        meta: {
          adminPermission: ADMIN_PERMISSIONS.VIEW_IMOBANCO_FEES,
        },
      },
      {
        path: 'fee/create',
        name: 'Admin - Cadastro de Taxas Imoabanco',
        component: () => import('@/view/pages/admin/taxas_imobanco/feeCreate.vue'),
      },
      {
        path: 'bloqueios',
        component: () => import('@/view/pages/admin/bloqueios/Bloqueios.vue'),
        meta: {
          adminPermission: ADMIN_PERMISSIONS.VIEW_VALUE_BLOCKAGE_PANEL,
        },
        children: [
          {
            path: '',
            name: 'Bloqueios',
            redirect: '/admin/bloqueios/valores',
          },
          {
            path: 'valores',
            name: 'Bloqueio de Valores',
            component: () => import('@/view/pages/admin/bloqueios/pages/Valores.vue'),
          },
          {
            path: 'titulos',
            name: 'Títulos',
            component: () => import('@/view/pages/admin/bloqueios/pages/Titulos.vue'),
          },
        ],
      },
      {
        path: 'client/onboarding',
        name: 'Admin - Listagem de Onboarding',
        component: () => import('@/view/pages/admin/clients/OnboardingOverview.vue'),
        meta: {
          adminPermission: ADMIN_PERMISSIONS.VIEW_REGISTRATION_REQUESTS,
          hiddenForLinkedAdmin: true,
        },
      },
      {
        path: 'client/onboarding/:document',
        name: 'Admin - Validar Cliente',
        component: () => import('@/view/pages/admin/clients/pages/OnboardingValidation.vue'),
      },
      {
        path: 'client/list',
        name: 'Admin - Lista de Clientes',
        component: () => import('@/view/pages/admin/clients/ClientsOverview.vue'),
        meta: {
          adminPermission: ADMIN_PERMISSIONS.VIEW_CLIENT_ACCOUNT_DATA,
        },
      },
      {
        path: 'client/profile/:document',
        name: 'Admin - Informações do Cliente',
        component: () => import('@/view/pages/admin/clients/pages/ClientsInfo.vue'),
      },
      {
        path: 'debentures',
        component: () => import('@/view/pages/admin/debentures/DebenturesAdmin.vue'),
        meta: {
          adminPermission: ADMIN_PERMISSIONS.VIEW_DEBENTURES_PANEL,
        },
        children: [
          {
            path: '',
            name: 'Admin debentures',
            redirect: '/admin/debentures/movimentacoes',
          },
          {
            path: 'movimentacoes',
            name: 'Movimentações',
            component: () =>
              import('@/view/pages/admin/debentures/DebenturesOperationsWithdraw.vue'),
          },
          {
            path: 'operacoes',
            name: 'Operações',
            component: () => import('@/view/pages/admin/debentures/DebenturesOperations.vue'),
          },
          {
            path: 'tributacao',
            name: 'Tributação',
            component: () =>
              import('@/view/pages/admin/debentures/DebenturesOperationsTaxations.vue'),
          },
          {
            path: 'tarifacao',
            name: 'Tarifação',
            component: () => import('@/view/pages/admin/debentures/DebenturesOperationsFees.vue'),
          },
          {
            path: 'aplicacao',
            name: 'Aplicação',
            component: () => import('@/view/pages/admin/debentures/DebenturesApplications.vue'),
          },
        ],
      },
      {
        // Rota antiga, absorvida pela aba de Reconhecimento do painel de Cash In.
        // Mantida como redirect pra não quebrar links/favoritos existentes.
        path: 'reconhecer_deposito',
        redirect: '/admin/cash_in/reconhecimento',
      },
      {
        path: 'calendario',
        name: 'Calendário de Feriados e horários úteis',
        component: () => import('@/view/pages/admin/calendar/Overview.vue'),
      },
      {
        path: 'change_limits/:client/',
        name: 'Alteração de Limites de Transações',
        component: () => import('@/view/pages/admin/limites_de_transacoes/ChangeLimits.vue'),
      },
      {
        path: 'permissions',
        name: 'Permissões de Usuários',
        component: () => import('@/view/pages/admin/permissoes/Permissions.vue'),
        meta: {
          adminPermission: ADMIN_PERMISSIONS.ADMINISTRATIVE_USER_REGISTRATION,
        },
      },
      {
        path: 'commission',
        component: () => import('@/view/pages/admin/commission/Overview.vue'),
        meta: {
          adminPermission: ADMIN_PERMISSIONS.VIEW_INDICATIONS_AND_PARTNERSHIP_PANEL,
        },
        children: [
          {
            path: '',
            name: 'Parceiros e Indicações',
            redirect: '/admin/commission/indications',
          },
          {
            path: 'indications',
            name: 'Listagem Admin de Indicações',
            component: () => import('@/view/pages/admin/commission/tabs/Indications.vue'),
          },
          {
            path: 'plans',
            name: 'Listagem Admin de Planos',
            component: () => import('@/view/pages/admin/commission/tabs/Plans.vue'),
          },
          {
            path: 'commissions',
            name: 'Listagem Admin de Comissões',
            component: () => import('@/view/pages/admin/commission/tabs/Commissions.vue'),
          },
        ],
      },
      {
        path: 'antecipacao',
        component: () => import('@/view/pages/admin/antecipacao/Overview.vue'),
        meta: {
          adminPermission: ADMIN_PERMISSIONS.VIEW_DEBT_ADVANCEMENT_PANEL,
        },
        children: [
          {
            path: '',
            name: 'Admin Antecipação de Recebíveis',
            redirect: '/admin/antecipacao/antecipacoes',
          },
          {
            path: 'propostas', //path: 'solicitacoes_e_propostas',
            name: 'Propostas de Antecipação',
            component: () =>
              import('@/view/pages/admin/antecipacao/pages/AntecipacoesPropostas.vue'),
          },
          {
            path: 'antecipacoes',
            name: 'Antecipações',
            component: () => import('@/view/pages/admin/antecipacao/pages/Antecipacoes.vue'),
          },
          {
            path: `antecipacoes/:anticipation(${UUID_PATTERN})`,
            name: 'Detalhes de Antecipação (Solicitação)',
            component: () => import('@/view/pages/admin/antecipacao/pages/AntecipacaoDetalhe.vue'),
          },
          {
            path: `antecipacoes/:anticipation(${UUID_PATTERN})/status_titulos`,
            name: 'Status dos Títulos de Antecipação (Solicitação)',
            component: () =>
              import('@/view/pages/admin/antecipacao/tabs/AntecipacaoTituloStatusTab.vue'),
          },
          {
            path: `antecipacoes/:anticipation(${UUID_PATTERN})/saldo_devedor`,
            name: 'Detalhe saldo devedor (Solicitação)',
            component: () => import('@/view/pages/shared/antecipacao/Pages/SaldoDevedor.vue'),
          },
          {
            path: `antecipacoes/:interest(${UUID_PATTERN})/criar_proposta`,
            name: 'Cadastrar Proposta de Antecipação',
            component: () =>
              import('@/view/pages/admin/antecipacao/pages/AntecipacoesCriarProposta.vue'),
          },
          {
            path: 'clientes',
            name: 'Clientes de Antecipação',
            component: () =>
              import('@/view/pages/admin/antecipacao/pages/AntecipacoesClienteLista.vue'),
          },
          {
            path: 'contabilidade',
            name: 'Contabilidade de Antecipação',
            component: () =>
              import('@/view/pages/admin/antecipacao/tabs/AntecipacoesContabilidadeTab.vue'),
          },
          {
            path: 'scoring',
            name: 'Scoring de Crédito',
            component: () =>
              import('@/view/pages/admin/antecipacao/tabs/AntecipacoesScoringTab.vue'),
          },
          {
            path: `cliente/:id(${UUID_PATTERN})`,
            component: () =>
              import('@/view/pages/admin/antecipacao/pages/AntecipacoesClienteDetalhes.vue'),
            children: [
              {
                path: '',
                name: 'Antecipações por Cliente',
                redirect: to => ({
                  path: `/admin/antecipacao/cliente/${to.params.id}/antecipacoes`,
                }),
              },
              {
                path: 'propostas',
                name: 'Propostas de Antecipação por Cliente',
                component: () =>
                  import('@/view/pages/admin/antecipacao/pages/AntecipacoesPropostas.vue'),
              },
              {
                path: 'antecipacoes',
                component: () => import('@/view/pages/admin/antecipacao/pages/Antecipacoes.vue'),
              },
              {
                path: 'carteira',
                name: 'Carteira passível de Antecipação por Cliente',
                component: () =>
                  import('@/view/pages/admin/antecipacao/tabs/AntecipacaoClienteCarteiraTab.vue'),
              },
              {
                path: 'carteira/status_titulos',
                name: 'Status dos Títulos da Carteira por Cliente',
                component: () =>
                  import('@/view/pages/admin/antecipacao/tabs/AntecipacaoTituloStatusTab.vue'),
              },
              {
                path: `antecipacoes/:anticipation(${UUID_PATTERN})`,
                name: 'Detalhe de Antecipação por Cliente',
                component: () =>
                  import('@/view/pages/admin/antecipacao/pages/AntecipacaoDetalhe.vue'),
              },
            ],
          },
          {
            path: `situacao_titulos/:id(${UUID_PATTERN})`,
            name: 'Situação dos Títulos de Antecipação',
            component: () =>
              import('@/view/pages/admin/antecipacao/tabs/AntecipacoesDebtsSituationTab.vue'),
          },
          // {
          //   path: 'operacoes',
          //   name: 'Operações',
          //   component: () => import('@/view/pages/admin/debentures/DebenturesOperations.vue'),
          // },
          // {
          //   path: 'tributacao',
          //   name: 'Tributação',
          //   component: () =>
          //     import('@/view/pages/admin/debentures/DebenturesOperationsTaxations.vue'),
          // },
          // {
          //   path: 'tarifacao',
          //   name: 'Tarifação',
          //   component: () => import('@/view/pages/admin/debentures/DebenturesOperationsFees.vue'),
          // },
          // {
          //   path: 'aplicacao',
          //   name: 'Aplicação',
          //   component: () => import('@/view/pages/admin/debentures/DebenturesApplications.vue'),
          // },
        ],
      },
      {
        path: `antecipacao/:anticipation(${UUID_PATTERN})`,
        name: 'Detalhes de Antecipação',
        component: () => import('@/view/pages/admin/antecipacao/pages/AntecipacaoDetalhe.vue'),
      },
      {
        path: `antecipacao/:anticipation(${UUID_PATTERN})/status_titulos`,
        name: 'Status dos Títulos de Antecipação',
        component: () =>
          import('@/view/pages/admin/antecipacao/tabs/AntecipacaoTituloStatusTab.vue'),
      },
      {
        path: `antecipacao/:anticipation(${UUID_PATTERN})/saldo_devedor`,
        name: 'Detalhe saldo devedor',
        component: () => import('@/view/pages/shared/antecipacao/Pages/SaldoDevedor.vue'),
      },
      {
        path: `antecipacao/clientes/:id(${UUID_PATTERN})`,
        name: 'Detalhe de Antecipação por Clientes',
        component: () =>
          import('@/view/pages/admin/antecipacao/pages/AntecipacoesClienteDetalhes.vue'),
      },
      {
        path: `antecipacao/clientes/:id(${UUID_PATTERN})/status_titulos`,
        name: 'Status dos Títulos da Carteira do Cliente',
        component: () =>
          import('@/view/pages/admin/antecipacao/tabs/AntecipacaoTituloStatusTab.vue'),
      },
      {
        path: `antecipacao/propostas/:id(${UUID_PATTERN})`, //path: 'solicitacoes_e_propostas/:id',
        name: 'Detalhes de Proposta de Antecipação',
        component: () =>
          import('@/view/pages/admin/antecipacao/pages/AntecipacoesPropostaDetalhe.vue'),
      },
    ],
  },
]

export default admin
